export const ERROR_CODES = {
  TOKEN_EXPIRED: 'No-Token',
} as const;
